import VideoModel from '@/dex-shared/models/VideoModel';

export default {
  videoById: (state: any, getters: any) => (videoId: number) => {
    const video = state.videos[videoId];
    if (video) {
      return new VideoModel(video, getters);
    } else {
      return {};
    }
  },
};
